import { $ } from 'utils/dom';

const backToTop = $('button.back-to-top');
if (backToTop) {
  const receiveFocusAfterKeydown = $('.skip-nav__button');
  backToTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  backToTop.addEventListener('keydown', event => {
    if (event.key === 'Enter') {
      receiveFocusAfterKeydown.focus();
    }
  });
}
